import { useGoogleTagManager } from './use-google-tag-manager';
import { useHotjar } from './use-hotjar';
import { useSentry } from './use-sentry';

export const use3pScriptLoader = () => {
    useSentry();
    useGoogleTagManager();
    useHotjar();
};
